import React from 'react';
import { motion } from 'framer-motion';

const ParticleBackground: React.FC = () => {
  return (
    <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden" aria-hidden="true">
      <div className="noise-bg mix-blend-overlay opacity-[0.15]"></div>

      {/* Global Slow-moving large organic blobs */}
      <motion.div
        animate={{
          x: [0, 40, 0],
          y: [0, -50, 0],
          scale: [1, 1.1, 1],
        }}
        transition={{ duration: 20, repeat: Infinity, ease: "easeInOut" }}
        className="absolute rounded-full"
        style={{
          top: '10%', left: '-5%', width: '60vw', height: '60vw', maxWidth: '600px', maxHeight: '600px',
          background: 'radial-gradient(circle, rgba(14, 165, 233, 0.15) 0%, transparent 60%)',
          filter: 'blur(80px)',
        }}
      />
      <motion.div
        animate={{
          x: [0, -40, 0],
          y: [0, 40, 0],
          scale: [1, 1.2, 1],
        }}
        transition={{ duration: 25, repeat: Infinity, ease: "easeInOut", delay: 2 }}
        className="absolute rounded-full"
        style={{
          top: '40%', right: '-10%', width: '70vw', height: '70vw', maxWidth: '700px', maxHeight: '700px',
          background: 'radial-gradient(circle, rgba(236, 72, 153, 0.1) 0%, transparent 60%)',
          filter: 'blur(90px)',
        }}
      />
      <motion.div
        animate={{
          x: [0, 50, 0],
          y: [0, 30, 0],
          scale: [1, 1.1, 1],
        }}
        transition={{ duration: 22, repeat: Infinity, ease: "easeInOut", delay: 5 }}
        className="absolute rounded-full"
        style={{
          bottom: '10%', left: '20%', width: '50vw', height: '50vw', maxWidth: '500px', maxHeight: '500px',
          background: 'radial-gradient(circle, rgba(139, 92, 246, 0.15) 0%, transparent 60%)',
          filter: 'blur(100px)',
        }}
      />
    </div>
  );
};

export default ParticleBackground;